import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isLoadingListingData: true,
  loading: false,
  error: null,
  orders: null,
  fetchingDropdown: false,
  loaderForModal: false,
  dropdowns: {},
  statusUnderUpdate: {},
  orderUnderUpdate: {},
  reportUploadInProgress: {},
  orderCount: {
    pending: 0,
    receivedAtLab: 0,
    underTesting: 0,
    reportUploaded: 0,
    underDispute: 0,
    completed: 0,
    rejectedByLab: 0,
    regret: 0,
  },
  totalOrders: 0,
  downloadInProgress: false,
  rejectOrderInProgress: false,
  commodities: [],
  activeNavOption: "PENDING"
};

const orderListingSlice = createSlice({
  name: "labOrderListing",
  initialState,
  reducers: {
    fetchOrders(state, action) {
      state.isLoadingListingData = true;
      state.orders = [];
    },
    fetchOrdersSuccess(state, action) {
      state.orders = action.payload.data.document;
      state.totalOrders = action.payload.count;
      state.isLoadingListingData = false;
    },
    fetchOrdersFailure(state, action) {
      state.isLoadingListingData = false;
    },
    fetchOrderCounts(state, action) {
      state.loading = true;
    },
    fetchOrderCountsSuccess(state, action) {
      state.orderCount = {
        pending: action.payload.data.document.pendingOrders,
        receivedAtLab: action.payload.data.document.receivedAtLabOrders,
        underTesting: action.payload.data.document.underTestingOrders,
        reportUploaded: action.payload.data.document.reportUploadedOrders,
        underDispute: action.payload.data.document.underDisputeOrders,
        completed: action.payload.data.document.completedOrders,
        rejectedByLab: action.payload.data.document.rejectedByLabOrders,
        regret: action.payload.data.document.regretOrders,
      };
      state.loading = false;
    },
    fetchOrderCountsFailure(state, action) {
      state.loading = false;
    },
    fetchDropdown(state, action) {
      state.fetchingDropdown = true;
    },
    fetchDropdownSuccess(state, action) {
      state.fetchingDropdown = false;
      state.dropdowns = action.payload.data.document;
    },
    fetchDropdownFailure(state, action) {
      state.fetchingDropdown = false;
    },
    updateOrderStatus(state, action) {
      state.statusUnderUpdate[action.payload.id] = true;
    },
    updateOrderStatusSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order?._id === action?.payload?.data?.document?._id
      );
      if (index !== -1) state.orders[index] = action?.payload?.data?.document;
      state.statusUnderUpdate[action?.payload?.data?.document?._id] = false;
    },
    updateOrderStatusFailure(state, action) {
      state.statusUnderUpdate[action.payload?.id] = false;
      state.error = action.payload?.error || "something went wrong";
    },
    uploadReport(state, action) {
      state.reportUploadInProgress[action.payload.id] = true;
    },
    uploadReportSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order._id === action.payload.data.document._id
      );
      if (index !== -1) state.orders[index] = action.payload.data.document;
      state.reportUploadInProgress[action.payload.id] = false;
    },
    uploadReportFailure(state, action) {
      state.reportUploadInProgress[action.payload.id] = false;
      state.error = action.payload.message;
    },
    downloadFile(state, action) {
      state.downloadInProgress = true;
    },
    downloadFileSuccess(state, action) {
      state.downloadInProgress = false;
    },
    downloadFileFailure(state, action) {
      state.downloadInProgress = false;
    },
    updateOrder(state, action) {
      state.orderUnderUpdate[action.payload.id] = true;
    },
    updateOrderSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order._id === action.payload.data.document._id
      );
      if (index !== -1) state.orders[index] = action.payload.data.document;
      state.orderUnderUpdate[action.payload.data.document._id] = false;
    },
    updateOrderFailure(state, action) {
      state.orderUnderUpdate[action.payload.id] = false;
      state.error = action.payload.error;
    },
    initializeError(state, action) {
      state.error = null;
    },
    triggerLoaderForModal(state, action) {
      state.loaderForModal = true;
    },
    stopLoaderForModal(state, action) {
      state.loaderForModal = false;
    },
    rejectOrder(state, action) {
      state.rejectOrderInProgress = true;
    },
    rejectOrderSuccess(state, action) {
      state.rejectOrderInProgress = false;
    },
    rejectOrderFailure(state, action) {
      state.rejectOrderInProgress = false;
      state.error = action.payload.error;
    },

    fetchCommodities(state) {
      state.commodities = [];
    },
    fetchCommoditiesSuccess(state, action) {
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {},
    
    setActiveNavOption(state, action) {
      state.activeNavOption = action.payload;
    },
    
  },
});

export const { actions, reducer, name: sliceKey } = orderListingSlice;
